import { Checkbox } from 'semantic-ui-react';

type Props = {
  label: string;
  checked: boolean;
  onClick: (checked: boolean) => void;
  disabled?: boolean;
};

const RiskCheckbox = ({ label, checked, onClick, disabled }: Props) => (
  <Checkbox
    label={label}
    type="checkbox"
    name="affectedGroup"
    checked={checked}
    onClick={onClick}
    disabled={disabled}
  />
);

export default RiskCheckbox;
